export const storageAuthKey = '@GPAAuth' as const
